<template lang="pug">
	.version-settings(v-if="showed && project && version")
		.card
			.card-header
				i.fa.fa-gear
				span Version Settings
			.card-body.collapse.show
				.version-icon(v-if="project.type === 'end-card'" :style="{backgroundImage: Version.getVersionScreenshot(project, version)}")
				.form-horizontal
					.info-group(v-if="project.type === 'playable'")
						.info-base(v-if="version.Tags.base") This is a base version which created by the developers. You can't rename it or make hidden.
						.info-custom(v-if="!version.Tags.base") This is a custom version created from "{{Version.Versions[version.baseVersionId].codename}}" base version.
					.form-group.separator(:class="{short: project.type === 'end-card'}")
						label.col-form-label Title of the version
							.controls
								input.form-control.title(size="16" type="text" v-model="title" :disabled="version.Tags.base" @input="updateTitle")
					.form-group.separator.short-content(v-if="project.type === 'end-card'")
						label.col-form-label For the projects with specified markers only
						.marker-list
							button.project-marker.btn(:class="{'btn-outline-dark': !_.includes(version.options.endCardMarkers, marker), 'btn-primary': _.includes(version.options.endCardMarkers, marker)}" type="button" @click="changeEndCardMarker(marker)" v-for="(markerData, marker) in publisher.options.projectMarkers") {{marker}}
					.form-group.separator(v-if="!version.Tags.base")
						label Hidden version
						label.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
							input.switch-input.form-check-input(type="checkbox" v-model="hidden" @change="saveVersionHiddenStatus($event.target.checked)")
							span.switch-slider(data-checked="On" data-unchecked="Off")
					.form-actions
						button.btn.btn-danger.delete-version-button(type="button" v-if="!version.Tags.base" v-on:click="deleteVersion()" v-b-tooltip.hover.v-danger="{delay: { show: 500, hide: 100 }, title: 'Delete version'}")
							i.fa.fa-remove
							span Delete
						button.btn.btn-primary(type="button" v-if="project.type === 'end-card'" v-on:click="takeScreenshot()" v-b-tooltip.hover.v-danger="{delay: { show: 500, hide: 100 }, title: 'Save version screenshot'}")
							i.fa.fa-camera
							span Save screenshot
						button.btn.btn-warning(v-if="project.type === 'playable' && !version.Tags.base" type="button" v-on:click="openProjectsDropdown($event)" :disabled="targetProjects.length === 0")
							i.fa.fa-arrow-right
							span Move to
						button.btn.btn-dark(type="button" v-on:click="hide()") Close
</template>

<script>

	import Screen 				from './../../mixins/screen';

	import SetupSettings		from "./../../settings/settings";

	export default {
		name: "VersionSettings",
		mixins: [Screen],
		screen: {
			updateOn: ["Version End Card Markers Changed", "Version Screenshot Changed"]
		},
		data() {

			this.targetProjects = [];
			this.version = null;

			return {
				title: '',
				hidden: false
			}

		},
		methods: {
			collectData(event, versionId) {

				if (event === 'show') this.version = Version.Versions[versionId];
				else if (this.version) this.version = Version.Versions[this.version.id];

				if (!this.version) return;

				this.project = Project.SelectedProject;
				this.publisher = Publisher.Publishers[this.project['publisher_id']];

				this.title = this.version.codename || this.version.title;
				this.hidden = !!(this.version.Tags['hidden']);

				this.targetProjects = _.filter(Project.getOrderedProjectsList(Publisher.SelectedPublisher), project => {

					return ((project.options.gitRepositoryName === this.project.options.gitRepositoryName && project.options.gitBranchName !== this.project.options.gitBranchName)
						|| _.intersection(project.options.markers || [], this.project.options.markers || []).length > 0) && project.id !== this.project.id;

				}).map(project => {

					return {title: project.title, name: project.id};

				});

			},
			updateTitle() {

				Server.sendWithTimeout({
					RenameVersion: {
						versionId: this.version.id,
						title: this.title.trim()
					}
				}, null, 200);

			},
			changeEndCardMarker(projectMarkerName) {

				if (_.includes(this.version.options.endCardMarkers, projectMarkerName)) {

					Server.sendToServer({
						UnsetEndCardVersionMarker: {
							versionId: this.version.id,
							projectMarkerName: projectMarkerName
						}
					});

				} else {

					Server.sendToServer({
						SetEndCardVersionMarker: {
							versionId: this.version.id,
							projectMarkerName: projectMarkerName
						}
					});

				}

			},
			saveVersionHiddenStatus(isHide) {

				if (isHide) {

					Server.sendToSocket({
						HideVersion: this.version.id
					});

				} else {

					Server.sendToSocket({
						ShowVersion: this.version.id
					});

				}

			},
			deleteVersion() {

				Broadcast.call("Show ProjectVersionActionsDelete", [this.version.id]);

				this.hide();

			},
			takeScreenshot() {

				Broadcast.call("Send To iFrame", [{TakeScreenshot: true}]);

				Broadcast.once(`IFrame Data:EndCardScreenshot`, base64Data => {

					let formData = new FormData();

					formData.append("versionId", this.version.id);
					formData.append("screenshotData", base64Data);

					let url = `http://${SetupSettings["domain"]}/version/screenshot`;
					if (location.protocol === 'https:') url = `https://${SetupSettings["domain"]}/version/screenshot`;

					let xhr = new XMLHttpRequest();

					xhr.withCredentials = true;

					xhr.open("POST", url);

					xhr.upload.onprogress = e => {

						if (e.lengthComputable) {

							this.version.uploadProgress = e.loaded / e.total;
							Broadcast.call('Version Screenshot Upload Progress', [this.version]);

						}

					};

					xhr.upload.onloadstart = e => {

						this.version.isUploading = true;
						Broadcast.call('Version Screenshot Upload Progress', [this.version]);

					};

					xhr.upload.onloadend = e => {

						this.version.isUploading = false;
						Broadcast.call('Version Screenshot Upload Progress', [this.version]);

					};

					xhr.send(formData);

				});

			},
			openProjectsDropdown(event) {

				Broadcast.call("Show ItemsDropdown", [event.target, this.targetProjects, {title: 'Move version to...'}, clickedProjectId => {

					Server.sendToSocket({
						MoveVersion: {
							versionId: this.version.id,
							projectId: clickedProjectId
						}
					});

					this.hide();

				}]);

			}
		}
	}
</script>

<style lang="sass">

	.version-settings
		display: flex
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)
		justify-content: center
		align-items: center

		.separator
			padding-bottom: 20px
			border-bottom: 1px solid rgba(0, 0, 0, 0.3)
			margin-bottom: 10px

		.info-group
			padding-bottom: 20px
			border-bottom: 1px solid rgba(0, 0, 0, 0.3)
			margin-bottom: 10px

		.form-group
			display: flex
			flex-direction: column

			.switch-slider
				background-color: #343b41
				border: 1px solid #23282c

		.form-group.short
			width: 320px

		.form-group.short-content
			padding-right: 160px

		.form-group-row
			display: flex
			flex-direction: row
			flex-wrap: nowrap
			padding-bottom: 0

		.version-icon
			position: absolute
			right: 20px
			top: 59px
			height: calc(1920px / 10)
			width: calc(1080px / 10)
			background-size: contain
			background-repeat: no-repeat
			background-position: center

		.card
			width: 500px
			margin: auto
			display: flex
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			.form-actions
				margin-top: 20px

			input.title
				width: 300px
				margin-top: 5px

			.btn-primary

				i
					margin-right: 10px

			.btn-danger, .btn-warning
				margin-right: 10px

				i
					margin-right: 10px

			.btn-warning, .btn-warning:active:focus
				color: #FFFFFF

			.btn-dark
				float: right
				color: #fff

			.title-row
				display: flex
				flex-direction: row
				justify-content: space-between
				align-items: center

			button.project-marker
				margin-right: 10px

</style>

